import React from "react";
import PageHeader from "./PageHeader";

const ShellsPage = () => {
  return <PageHeader>Shells</PageHeader>;
};

export default ShellsPage;
